import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const BuildingOfficeSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  const { className = '', ...rest } = props

  return (
    <div {...rest} className={`inline-flex items-center justify-center ${className}`}>
      <svg className="block w-full h-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.5 20.25V6.75C4.5 6.33579 4.83579 6 5.25 6H13.5C13.9142 6 14.25 6.33579 14.25 6.75V20.25M14.25 10.5H18.75C19.1642 10.5 19.5 10.8358 19.5 11.25V20.25M3 20.25H21M8.25 9H10.5M8.25 12.75H10.5M8.25 16.5H10.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default BuildingOfficeSvg
